(function () {
  function initTeamGallery(gallery) {
    var cards = gallery.querySelectorAll(".fw-about-fwp__team-card");
    if (!cards.length) return;

    var first = cards[0];

    function setActive(card) {
      for (var i = 0; i < cards.length; i++) {
        var isActive = cards[i] === card;
        cards[i].classList.toggle("is-active", isActive);
        cards[i].setAttribute("aria-expanded", isActive ? "true" : "false");
      }
    }

    setActive(first);

    for (var j = 0; j < cards.length; j++) {
      (function (card) {
        card.addEventListener("mouseenter", function () {
          setActive(card);
        });
        card.addEventListener("focusin", function () {
          setActive(card);
        });
      })(cards[j]);
    }

    gallery.addEventListener("mouseleave", function () {
      setActive(first);
    });
  }

  function boot() {
    var galleries = document.querySelectorAll("[data-fw-team-gallery]");
    for (var i = 0; i < galleries.length; i++) {
      initTeamGallery(galleries[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
